document.addEventListener('DOMContentLoaded', function() {
  var sidebars = document.querySelectorAll('#CollectionSection .collection-menu-sidebar');

  sidebars.forEach(function(sidebar) {
    var toggle = sidebar.querySelector('.collection-menu-sidebar__toggle');
    var list = sidebar.querySelector('.collection-menu-sidebar__list');

    if (!toggle || !list) return;

    toggle.addEventListener('click', function() {
      var collapsed = sidebar.classList.toggle('is-collapsed');
      toggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
    });
  });
});
